module.exports = __webpack_public_path__ + "img/9W.487ab594.jpg";